__turbopack_context__.v({
  "closeButton": "dialog-module-scss-module__SAc50G__closeButton",
  "dialogContent": "dialog-module-scss-module__SAc50G__dialogContent",
  "dialogDescription": "dialog-module-scss-module__SAc50G__dialogDescription",
  "dialogHeader": "dialog-module-scss-module__SAc50G__dialogHeader",
  "dialogTitle": "dialog-module-scss-module__SAc50G__dialogTitle",
  "overlay": "dialog-module-scss-module__SAc50G__overlay",
});
